import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '@/common-utils/components/ui/modal';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import actionsPosTerminals from '../../../api/actionsPosTerminals';
import PropTypes from 'prop-types';
import { useToast } from '@/common-utils/hooks/use-toast';
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalRewarehousePosTerminal Component
 */
function ModalRewarehousePosTerminal({ trigger, isOpen, setIsOpen, subscriptionId, setLaunchRefetch }) {

    // Toast
    const { toast } = useToast();

    // API Calls
    const onSuccess = () => {
        setLaunchRefetch(true);
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.rewarehouse.success'} namespace={nsTerminal} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.rewarehouse.error'} namespace={nsTerminal} />,
            variant: 'danger'
        });
    };
    const submitRewarehousePosTerminal = actionsPosTerminals.rewarehousePosTerminal(onSuccess, onError);

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.rewarehouse.title'} namespace={nsTerminal} />
            <ModalBody>
                <div className={'mb-4'}>
                    <Entity entity={'modal.rewarehouse.text_1'} namespace={nsTerminal} />
                </div>
                <div className={'mb-4'}>
                    <Entity entity={'modal.rewarehouse.text_2'} namespace={nsTerminal} />
                </div>
                <Entity entity={'modal.rewarehouse.text_3'} namespace={nsTerminal} />
            </ModalBody>
            <FooterForm
                onSubmit={() => submitRewarehousePosTerminal.mutate({ subscriptionId })}
                isSubmitting={submitRewarehousePosTerminal.isLoading}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            {content}
        </Modal>
    );
}

ModalRewarehousePosTerminal.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    subscriptionId: PropTypes.string,
    setLaunchRefetch: PropTypes.func
};

export default ModalRewarehousePosTerminal;